const fhirDuration = [
  { value: 'd', label: 'Day' },
  { value: 'wk', label: 'Week' },
  { value: 'mo', label: 'Month' },
  { value: 'a', label: 'Year' },
];

export default fhirDuration;
